import {
  DELETE_INVENTORY_REQUEST,
  DELETE_INVENTORY_SUCCESS,
  DELETE_INVENTORY_FAILURE,
} from "./deleteInventoryTypes";

const initialState = {
  loading: false,
  inventory: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_INVENTORY_SUCCESS:
      return {
        loading: false,
        inventory: action.payload,
        error: "",
      };
    case DELETE_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
